import React, { useEffect, useState } from "react";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import {
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Container,
} from "reactstrap";
import classnames from "classnames";
import CategoryWiseReport from "../component/CategoryWiseReport";
import ItemWiseReport from "../component/ItemWiseReport";
import ItemPercentReport from "../component/ItemPercentReport";
import CategoryServices from "../../../services/OrderingServices/CategoryService";

const SalesReportWise = () => {
  const [activeTab, setActiveTab] = useState("2");
  const [categoryData, setCategoryData] = useState([]);

  const toggle = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  // Fetch categories
  const fetchCategoryData = async () => {
    try {
      const response = await CategoryServices.maincategory();
      setCategoryData(response?.items || []);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  useEffect(() => {
    fetchCategoryData();
  }, []);

  return (
    <Container fluid>
      <div className="page-content">
        <BreadCrumb title="Stock Summary" pageTitle="Reports" />

        <div
          style={{
            background: "#ffffff",
            borderRadius: "0.5rem",
            boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
            border: "1px solid #eee",
            overflow: "hidden",
          }}
        >
          {/* Modern Tab Navigation */}
          <div
            style={{
              borderBottom: "2px solid #f0f0f0",
              padding: "0 1.5rem",
              background: "#fafafa",
            }}
          >
            <Nav tabs className="border-0">
              <NavItem>
                <NavLink
                  className={classnames({
                    active: activeTab === "2",
                    "border-0": true,
                    "px-4": true,
                    "py-3": true,
                  })}
                  onClick={() => toggle("2")}
                  style={{
                    cursor: "pointer",
                    fontWeight: activeTab === "2" ? "600" : "500",
                    color: activeTab === "2" ? "#0d6efd" : "#6c757d",
                    borderBottom:
                      activeTab === "2" ? "3px solid #0d6efd" : "none",
                    background: "transparent",
                    transition: "all 0.3s ease",
                  }}
                >
                  <i className="bx bx-box me-2"></i>
                  Product Wise
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({
                    active: activeTab === "1",
                    "border-0": true,
                    "px-4": true,
                    "py-3": true,
                  })}
                  onClick={() => toggle("1")}
                  style={{
                    cursor: "pointer",
                    fontWeight: activeTab === "1" ? "600" : "500",
                    color: activeTab === "1" ? "#0d6efd" : "#6c757d",
                    borderBottom:
                      activeTab === "1" ? "3px solid #0d6efd" : "none",
                    background: "transparent",
                    transition: "all 0.3s ease",
                  }}
                >
                  <i className="bx bx-category me-2"></i>
                  Category Wise
                </NavLink>
              </NavItem>

              <NavItem>
                <NavLink
                  className={classnames({
                    active: activeTab === "3",
                    "border-0": true,
                    "px-4": true,
                    "py-3": true,
                  })}
                  onClick={() => toggle("3")}
                  style={{
                    cursor: "pointer",
                    fontWeight: activeTab === "3" ? "600" : "500",
                    color: activeTab === "3" ? "#0d6efd" : "#6c757d",
                    borderBottom:
                      activeTab === "3" ? "3px solid #0d6efd" : "none",
                    background: "transparent",
                    transition: "all 0.3s ease",
                  }}
                >
                  <i className="bx bx-pie-chart-alt-2 me-2"></i>
                  Product Sales Percentage
                </NavLink>
              </NavItem>
            </Nav>
          </div>

          {/* Tab Content */}
          <TabContent activeTab={activeTab} className="p-0">
            <TabPane tabId="1">
              <CategoryWiseReport
                categoryData={categoryData}
                setCategoryData={setCategoryData}
              />
            </TabPane>

            <TabPane tabId="2">
              <ItemWiseReport
                categoryData={categoryData}
                setCategoryData={setCategoryData}
                fetchCategoryData={fetchCategoryData}
              />
            </TabPane>

            <TabPane tabId="3">
              <ItemPercentReport
                categoryData={categoryData}
                setCategoryData={setCategoryData}
                fetchCategoryData={fetchCategoryData}
              />
            </TabPane>
          </TabContent>
        </div>
      </div>
    </Container>
  );
};

export default SalesReportWise;
